export const MEDMO_CATEGORY = 'medical-imaging';

export const MEDMO_DISCLAIMER = `The content provided here and elsewhere about Medmo, Inc., d/b/a “Medmo” or Medmo’s services on the Solv Health site or mobile app is provided for general informational purposes only. It is not intended as, and should not be viewed as a medical advice, recommendation, or guarantee of services or results by Solv Health. Solv Health, Inc. does not provide, medical advice, diagnosis or treatment. Always contact your healthcare provider directly with any questions you may have regarding your health or specific medical advice.`;

export const MedmoUrls = {
  base: 'http://app.medmo.com/solv',
};
